module.exports = __webpack_public_path__ + "static/media/newarrival-5.1e640ab5.jpg";